import Vue from "vue";
import Vuex from "vuex";
import axios from "@/assets/js/axiosExtend.js";
// import { GetUserAuth } from 'tvu-common-ui'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    initConfig: {},
    loginInfo: {},
    serverFunctionList: null
  },
  getters: {},
  mutations: {
    saveInitConfig (state, val) {
      state.initConfig = val
      Vue.prototype.$TVU = {
        http: axios,
        userGroup: state.initConfig.versionControl.versionApiUrl,
        serverName: state.initConfig.serverName,
        userAuthUrl: state.initConfig.urlInfo ? state.initConfig.urlInfo.userAuth : '' // 后端配置的url地址
      }

      // Vue.prototype.$getUserAuth = GetUserAuth

      // GetUserAuth({
      //   http: axios,
      //   userGroup: state.initConfig.versionControl.versionApiUrl,
      //   params: {
      //     showAllPermission: true,
      //     serviceNameList: [state.initConfig.serverName]
      //   },
      //   success: function (val) {
      //     state.serverFunctionList = val
      //   },
      //   error: function (val) {
      //     console.log(val)
      //   }
      // })
    },
    saveLoginInfo (state, val) {
      state.loginInfo = val
    }
  },
  actions: {
    async getInitConfig ({ commit }) {
      await axios
        .get('/noc/base/initConfig ')
        .then(res => {
          if (!res) return
          if (res.data.errorCode == '0x0') {
            commit('saveInitConfig', res.data.result)
          }
        })
    },
    getLoginInfo ({ commit }) {
      axios
        .get('/noc/user/loginInfo')
        .then(res => {
          if (!res) return
          if (res.data.errorCode == '0x0') {
            commit('saveLoginInfo', res.data.result)
          }
        })
    }
  },
  modules: {},
});
